import React, { useEffect, useState, useRef, useMemo } from "react";
import MarkdownViewer from "./MarkdownViewer";

interface TextStepProps {
  text: string;
  onDone?: () => void;
}

const TextStep: React.FC<TextStepProps> = ({ text, onDone }) => {
  const words = useMemo(() => text.split(" "), [text]);
  const [index, setIndex] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    setIndex(0);
    doneRef.current = false;

    const timer = setInterval(() => {
      setIndex((prev) => {
        const next = prev + 1;
        if (next >= words.length) {
          clearInterval(timer);
          if (!doneRef.current) {
            doneRef.current = true;
            onDone?.();
          }
          return prev;
        }
        onDone?.();
        return next;
      });
    }, 50);

    return () => clearInterval(timer);
  }, [words.length, onDone]);

  return <MarkdownViewer content={words.slice(0, index + 1).join(" ")} />;
};

export default TextStep;
